module.exports = __webpack_public_path__ + "static/author-f3b4254f19b52be347fce0937cf0ac73.jpg";